const fragment = `
  id
  name
  description
  imageUrl
  isDefault
`;

export const listElevationsQuery = `
  query ListElevations(
    $filter: ElevationFilterInput
  ) {
    items: listElevations(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createElevationQuery = `
  mutation CreateElevation(
    $input: CreateElevationInput!
    $image: Upload
  ) {
    item: createElevation(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateElevationQuery = `
  mutation UpdateElevation(
    $input: UpdateElevationInput!
    $image: Upload
  ) {
    item: updateElevation(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteElevationQuery = `
  mutation DeleteElevation(
    $id: Int!
  ) {
    item: deleteElevation(id: $id) {
      ${fragment}
    }
  }
`;

export const sortElevationsQuery = `
  mutation SortElevations(
    $modelId: Int!,
    $ids: [Int!]!
  ) {
    items: sortElevations(modelId: $modelId, ids: $ids) {
     id
    }
  }
`;
